import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

Vue.use(VueTelInput, {}) // Define default global options here (optional)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import custom styles to override Bootstrap defaults
import './assets/scss/app.scss'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

let app = new Vue({
  router,
  store,
  render: h => h(App)
});

store.dispatch("getAutoRefreshInterval")
  .then(() => {
    app.$mount('#app');
  });
